import { Component, Inject, Optional } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { WidgetDescriptionDialog } from '../../../../features/store-portal/components/dialogs/widget-description-dialog.component';
import { BrowserStorage } from '../../../../utils/shared-services/browser-storage.service';
import { CaptionService } from '../../../../utils/shared-services/caption.service';

@Component({
    selector: 'hoWid001',
    templateUrl: 'src/app/features/head-office-portal/widgets/templates/wid-001.html',
    standalone: false
})
export class HoWid001 {
    public dateSelectedValue: string;
    public captions: any;
    public isTimedOut: boolean = false;
    public areDatapointsInvalid: boolean = true;
    public invalidDatapoints: any[] = [];
    public datapoints: any[] = [];

    public headers: string[];
    public labels: string[];
    public datasets: any;

    public storeName: any;
    public currencyCode: any;
    public storeInfo: any;
    public storeStatus: number = -1;
    hoPortalData: any;
    conceptID: number;
    widgetData: any;
    storeData: any;
    storesSelected: number = 0

    constructor(
        @Inject(Object) @Optional() private widget: any,
        @Inject(CaptionService) private captionService,
        @Inject(BrowserStorage) private browserStorage: BrowserStorage,
        @Inject(MatDialog) private dialog: MatDialog
    ) {
        this.captions = this.captionService.captions;

        this.hoPortalData = this.browserStorage.getSessionstorage('hoPortalData', null);
        this.storeName = this.hoPortalData?.StoreName;
        this.currencyCode = this.hoPortalData?.CurrencyCode;
        this.widgetData = this.hoPortalData?.DataSets.DataSet[4];
        this.conceptID = this.widgetData.Record[0].CONCEPTID;
        this.dateSelectedValue = this.browserStorage.getSessionstorage('widgetSelectedDate', null);
        if (this.widget?.id) {
            this.datapoints = this.browserStorage.getSessionstorage(this.widget.id, null);
        }
        this.headers = [this.captions.storeNo, this.captions.storeName, this.captions.openDateFront+" (Y/M/D)" ];
        this.labels = this.widgetData.Record.map(record => record.STORENUM.toString());
    }

    openInfoDialog() {
         this.dialog.open(WidgetDescriptionDialog, {
             panelClass: 'app-full-bleed-dialog',
             maxWidth: '95vw',
             data: {
                 widgetID: 'ho-' + this.widget.id,
             },
         });
    }

    ngOnInit() {
        // to change animation on wid-000
        if (this.widget && this.widget.isTimedOut) {
            this.isTimedOut = true;
            return;
        }

        if (!this.widget || !this.widget.isLoaded) {
            return;
        }

        // Verify datapoints, making sure they are not null or undefined
        this.areDatapointsInvalid = false;
        for (let i = 0; i < this.widget.data.length; i++) {
            if (!this.widget.data[i]) {
                this.areDatapointsInvalid = true;
                this.invalidDatapoints.push(this.datapoints[i]);
            }
        }
        if (this.areDatapointsInvalid) {
            return;
        }

        let data = this.widgetData.Record;
        if (!data) {
             return;
        }

        this.storeData = data.filter(item => this.widget.data[0].includes(item.STORENUM)).map(item => ({
            storeNum: item.STORENUM?.toString() ?? 'N/A',
            storeID: item.STOREID?.toString() ?? 'N/A',
            storeName: item.STORENAME ?? 'N/A',
            openDate: new Date(item.MAXOPENDATE).toISOString().slice(0, 10) ?? 'N/A'
        }));
        this.storesSelected = this.storeData.length;
    }
}
